import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  Grid,
  Paper,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  TableBody,
} from "@mui/material";

const ErrorText = ({ error, fieldLabel }) =>
  error ? (
    <Typography color="error" sx={{ fontSize: "12px", marginTop: "5px" }}>
      {fieldLabel ? `${fieldLabel}: ${error}` : error}
    </Typography>
  ) : null;

const CustomTable = ({
  label,
  fields,
  formData,
  handleInputChange,
  placeholder,
  errors,
  isOtherRow = false,
  dynamicLabel,
  handleDynamicLabelChange,
  disabled,
}) => (
  <>
    <TableRow sx={{ height: "20px" }}>
      <TableCell>
        {isOtherRow ? (
          <TextField
            disabled={disabled}
            value={dynamicLabel}
            onChange={(e) => handleDynamicLabelChange(e.target.value)}
            size="small"
            placeholder="Others-Please Specify"
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
          />
        ) : (
          label
        )}
      </TableCell>
      {isOtherRow ? (
        <TableCell>
          <TextField
            disabled={disabled}
            name="others"
            value={formData.other?.others || ""}
            onChange={(e) =>
              handleInputChange("other", "others", e.target.value)
            }
            size="small"
            placeholder="Enter %"
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
            error={!!errors.other?.others}
          />
          <ErrorText
            error={errors.other?.others}
            fieldLabel="Other - Please Specify"
          />
        </TableCell>
      ) : (
        fields.map((field) => (
          <TableCell key={field}>
            <TextField
              disabled={disabled}
              name={field}
              value={formData[field]}
              //   onChange={(e) => handleInputChange(null, field, e.target.value)}
              onChange={(e) => handleInputChange(e, field)}
              size="small"
              placeholder={placeholder}
              //   placeholder={placeholder[index]}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
              error={!!errors[field]}
            />
            {/* <ErrorText error={errors[field]} fieldLabel={label} /> */}
          </TableCell>
        ))
      )}
    </TableRow>
  </>
);

export default CustomTable;
